import React from 'react';
import './index.less';
import DrawerStore from '@/stores/drawer';
import PageStore from '@/stores/page';
import doLog from '@/common/log';

interface PropTypes {
  sampleInfo: SampleTypes.Root;
  sample: SampleTypes.Sample;
  i18n: DetailTypes.i18n;
  price: PriceTypes.Root;
  sampleInventory: SampleTypes.sampleInventory;
  productId: number;
  inventory: InventoryTypes.Root;
  sku: {
    skuAttrs: SkuTypes.SkuAttr[];
    skuInfoMap: InventoryTypes.SkuInfoMap;
  };
}

export default function index(props: PropTypes) {
  const { sampleInfo, sample, price, i18n, productId, inventory } = props;
  if (!sample) return null;
  const { skuList = [] } = sampleInfo;

  if (!price || !sampleInfo?.formatPrice) return null;

  const secondScreen = PageStore((state) => state.secondScreen);
  const { dialogShow } = DrawerStore((state) => state);

  const url = `//biz.alibaba.com/contract/SampleOrder.htm?data=${JSON.stringify([
    {
      productId,
      dispatchLocation: inventory.preferedDispatchId,
      skuId: '',
    },
  ])}&tracelog=from_detail_get_sample`;

  const handleClick = () => {
    if (skuList.length === 0) {
      window.location.href = url;
    } else {
      dialogShow({ type: 'sample' });
    }
  };
  return (
    <div className="sample-layout">
      <div className="sample-action">
        {i18n['detail_pc_sku_sample_number_1']?.replace('{0}', '')}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            doLog('/sc.details.getSampleLink', `second=${secondScreen}`);
            handleClick();
          }}
        >
          {i18n['detail_pc_sku_sample_combo']}
        </a>
      </div>
      <div className="sample-floor">
        <h3 className="att-title" id="samples">
          {i18n['btnGetSample.sample']}
        </h3>
        <div className="sample-item">
          {i18n['detail_pc_sku_sample_floor_max_order_quantity']} {sampleInfo.maxQuantity}{' '}
          {sample.priceUnit}
        </div>
        <div className="sample-item">
          <span>{i18n['detail_pc_sku_sample_floor_sample_price']}</span>
          <div className="price">
            <strong>
              {sampleInfo.formatPrice}/{sample.priceUnit}
            </strong>
            {sampleInfo.formatOriginalPrice && <del>{sampleInfo.formatOriginalPrice}</del>}
          </div>
        </div>
        <button
          className={'detail-simple'}
          onClick={() => {
            doLog('/sc.details.getSampleButton');
            handleClick();
          }}
        >
          {i18n['detail_pc_sku_sample_combo']}
        </button>
      </div>
    </div>
  );
}
